/**
 * Public Chat Page Route
 * 
 * Entry point for the public chat landing page.
 */

import React from 'react';
import { PublicChatPage } from 'features/public-chat';

const PublicChatRoute: React.FC = () => {
  return <PublicChatPage />;
};

export default PublicChatRoute;

